import orderBy from 'lodash.orderby';
import * as z from 'zod';

const interests = [
  'basketball',
  'golf',
  'running',
  'walking',
  'soccer',
  'volleyball',
  'badminton',
  'yoga',
  'pilates',
  'swimming',
  'ice skating',
  'roller skating',
  'figure skating',
  'rugby',
  'darts',
  'football',
  'barre',
  'tai chi',
  'stretching',
  'bowling',
  'ice hockey',
  'surfing',
  'tennis',
  'baseball',
  'gymnastics',
  'rock climbing',
  'dancing',
  'gardening',
  'karate',
  'horse racing',
  'snowboarding',
  'skateboarding',
  'cycling',
  'cheerleading',
  'archery',
  'fishing',
  'taekwondo',
  'fencing',
  'water skiing',
  'skiing',
  'jet skiing',
  'weight lifting',
  'scuba diving',
  'wind surfing',
  'kickboxing',
  'sky diving',
  'boxing',
  'board games',
  'brewery games',
  'table tennis',
  'hiking',
  'juggling',
  'jazzercise/aerobics',
  'cross country',
  'running track',
  'craft hobbies',
];

const interestsFormSchema = z.object({
  name: z.string(),
  value: z.string(),
});

export type InterestsFormSchema = z.infer<typeof interestsFormSchema>;

export function interestsSchema() {
  return z.array(interestsFormSchema);
}

export const getInterests = (usersInterests: InterestsFormSchema[]) => strToInterests(interests, usersInterests);

export const strToInterests = (
  commaSeparatedString?: string | string[] | null,
  usersInterests: InterestsFormSchema[] = []
): InterestsFormSchema[] => {
  let arr: string[] = [];
  const strArr = commaSeparatedString;
  if (strArr) {
    if (typeof strArr === 'string') {
      arr = strArr.split(',').map((item) => item.trim());
    } else {
      arr = strArr;
    }

    const actualInterests = arr.map((item) => ({ name: item, value: item }));
    const userInterests = (usersInterests ?? []).filter((item) => arr.includes(item.value.toLowerCase()));

    return orderBy([...actualInterests, ...userInterests], ['name']);
  }

  if (usersInterests.length > 0) {
    return [...usersInterests];
  }
  return [];
};

export const interestsToStr = (arr?: InterestsFormSchema[]) => {
  if (typeof arr === 'undefined' || arr?.length === 0) {
    return '';
  }
  const sorted = orderBy(arr, 'name').map((item) => item.value.trim());
  return sorted.join(',');
};
